import { Navigate, useParams, generatePath } from "react-router-dom";

const RedirectWithParams = ({ to }) => {
    const params = useParams();
    const path = generatePath(to, params);

    return <Navigate to={path} replace />;
};

export default RedirectWithParams;